export default __webpack_public_path__ + "assets/c28d8c859e2df3ac493079f7bf05eb50.svg";